import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "../pages/Login";
import LoginFormando from "../pages/Login/formando";
import Cadastro from "../pages/Login/Cadastro";
import PasswordRecovery from "../pages/Login/passwordRecovery";
import PasswordChange from "../pages/Login/passwordChange";
import Dashboard from "../pages/Dashboard";
import Business from "../pages/Business";
import Feed from "../pages/Business/Feed";
import Summary from "../pages/Business/Summary";
import Funil from "../pages/Business/Funil";
import Budget from "../pages/Business/Budget";
import TemplateBusiness from "../pages/Business/TemplateBusiness";
import TemplateBusinessEdith from "../pages/Business/TemplateBusinessEdith";
import Attendance from "../pages/Attendance";
import AttendanceMessage from "../pages/Attendance/AttendanceMessage";
import ManageBills from "../pages/Financial/ManageBills";
import BillsToReceive from "../pages/Financial/BillsToReceive";
import BillsToPay from "../pages/Financial/BillsToPay";
import Groups from "../pages/Groups";
import RegistrationData from "../pages/Groups/RegistrationData";
import RegistrationDataEdith from "../pages/Groups/RegistrationDataEdith";
import Graduate from "../pages/Groups/Graduate";
import Products from "../pages/Groups/Products";
import Charges from "../pages/Groups/Charges";
import Survey from "../pages/Groups/Survey";
import Draft from "../pages/Groups/Draft";
import GroupCalendar from "../pages/Groups/GroupCalendar";
import GroupAttendance from "../pages/Groups/GroupAttendance";
import GroupMessenger from "../pages/Groups/GroupAttendance/Messenger";
import Files from "../pages/Groups/Files";
import Costs from "../pages/Groups/Costs";
import Reports from "../pages/Reports";
import ReportsFinancial from "../pages/Reports/Financial";
import ReportsGroups from "../pages/Reports/Groups";
import ReportsBusiness from "../pages/Reports/Business";
import ReportsCalendar from "../pages/Reports/Calendar";
import ReportsOperational from "../pages/Reports/Operational";
import ReportsOperationalSuppliers from "../pages/Reports/OperationalSuppliers";
import ReportsEvents from "../pages/Reports/Events";
import ReportsTrainees from "../pages/Reports/Trainees";
import ReportsAttendance from "../pages/Reports/Attendance";
import ReportsAdditionalItems from "../pages/Reports/AdditionalItems";
import Suppliers from "../pages/Suppliers";
import SuppliersRegister from "../pages/Suppliers/SuppliersRegister";
import Institutions from "../pages/Institutions";
import InstitutionsEdit from "../pages/Institutions/InstitutionsEdit";
import Users from "../pages/Users";
import NewUser from "../pages/Users/NewUser";

// Trainees
import Trainees from "../pages/Trainees";
import TraineesRegister from "../pages/Trainees/TraineesRegister";
import TraineesFinancial from "../pages/Trainees/TraineesFinancial";
import TraineesAttendance from "../pages/Trainees/TraineesAttendance";
import TraineesCharges from "../pages/Trainees/TraineesCharges";
import TraineesProducts from "../pages/Trainees/TraineesProducts";
import TraineesAttendanceChat from "../pages/Trainees/TraineesAttendance/chat";

// Trainee Area
import Atendimento from "../pages/TraineeArea/atendimento";
import Mensagem from "../pages/TraineeArea/atendimento/mensagem";
import Arquivos from "../pages/TraineeArea/arquivos";
import Enquetes from "../pages/TraineeArea/enquetes";
import Dados from "../pages/TraineeArea/dados";
import Financeiro from "../pages/TraineeArea/financeiro";
import Produtos from "../pages/TraineeArea/produtos";
import Agenda from "../pages/TraineeArea/agenda";
import TraineeDashboard from "../pages/TraineeArea/dashboard";
import Formandos from "../pages/TraineeArea/formandos";

// Admin
import CostCenter from "../pages/Admin/CostCenter";
import AdminEvents from "../pages/Admin/Events";
import AdminResources from "../pages/Admin/Resources";
import AdminCalendar from "../pages/Admin/Calendar";
import AdminCompetitors from "../pages/Admin/Competitors";
import AdminUsers from "../pages/Admin/Users";
import AdminUserEdit from "../pages/Admin/Users/edit";
import PresetsPermissions from "../pages/Admin/PresetsPermissions";
import WhiteLabel from "../pages/Admin/WhiteLabel";

// Layouts
import MainLayout from "../pages/_layouts/Main";
import GroupLayout from "../pages/_layouts/Group";
import TraineeLayout from "../pages/_layouts/Trainee";
import TraineeAreaLayout from "../pages/_layouts/TraineeArea";
import LoginLayout from "../pages/_layouts/Login";

// Rules
import RequireAuthGestor from "../pages/_rules/RequireAuthGestor";
import RequireAuthFormando from "../pages/_rules/RequireAuthFormando";
import RequireNoAuth from "../pages/_rules/RequireNoAuth";
import Home from "../pages/_rules/pages/Home";
import NotFound from "../pages/404/NotFound";
import NoPermission from "../pages/404/NoPermission";
import RequireAdmin from "../pages/_rules/RequireAdmin";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<RequireNoAuth />}>
          <Route element={<LoginLayout />}>
            <Route path="/formando" element={<LoginFormando />} />
            <Route path="/gestor" exact element={<Login />} />
            <Route path="/password-recovery" exact element={<PasswordRecovery />} />
            <Route path="/password-change" exact element={<PasswordChange />} />
            <Route path="/cadastro/:code?" element={<Cadastro />} />
          </Route>
        </Route>
        <Route element={<RequireAuthFormando />}>
          <Route element={<TraineeAreaLayout />}>
            <Route path="/formando-dashboard" exact element={<TraineeDashboard />} sidebar={false} />
            <Route path="/formando-dashboard/meus-dados" exact element={<Dados />} sidebar={false} />
            <Route path="/formando-dashboard/atendimento/mensagem/:messageId?" element={<Mensagem />} sidebar={false} />
            <Route path="/formando-dashboard/atendimento" exact element={<Atendimento />} sidebar={false} />
            <Route path="/formando-dashboard/arquivos" element={<Arquivos />} sidebar={false} />
            <Route path="/formando-dashboard/enquetes" element={<Enquetes />} sidebar={false} />
            <Route path="/formando-dashboard/financeiro" element={<Financeiro />} sidebar={false} />
            <Route path="/formando-dashboard/produtos" element={<Produtos />} sidebar={false} />
            <Route path="/formando-dashboard/agenda" element={<Agenda />} sidebar={false} />
            <Route path="/formando-dashboard/formandos" element={<Formandos />} sidebar={false} />
          </Route>
        </Route>
        <Route element={<RequireAuthGestor />}>
          <Route element={<MainLayout />}>
            <Route element={<GroupLayout />}>
              <Route path="/groups/:commercialId/registrationdata" element={<RegistrationData />} />
              <Route path="/groups/:commercialId/registrationdataedith" element={<RegistrationDataEdith />} />
              <Route path="/groups/:commercialId/graduate" element={<Graduate />} />
              <Route path="/groups/:commercialId/products" element={<Products />} />
              <Route path="/groups/:commercialId/charges" element={<Charges />} />
              <Route path="/groups/:commercialId/survey" element={<Survey />} />
              <Route path="/groups/:commercialId/draft" element={<Draft />} />
              <Route path="/groups/:commercialId/calendar" element={<GroupCalendar />} />
              <Route path="/groups/:commercialId/attendance" element={<GroupAttendance />} />
              <Route path="/groups/:commercialId/attendance/:attendanceId" element={<GroupMessenger />} />
              <Route path="/groups/:commercialId/files" element={<Files />} />
            </Route>
            <Route element={<TraineeLayout />}>
              <Route path="/trainees/edit/:traineesId" element={<TraineesRegister />} />
              <Route path="/trainees/financial/:traineesId" element={<TraineesFinancial />} />
              <Route path="/trainees/attendance/:traineesId" element={<TraineesAttendance />} />
              <Route path="/trainees/attendance/:traineesId/:attendanceId" element={<TraineesAttendanceChat />} />
              <Route path="/trainees/charges/:traineesId" element={<TraineesCharges />} />
              <Route path="/trainees/products/:traineesId" element={<TraineesProducts />} />
            </Route>
            <Route path="/trainees/new/:groupId?" element={<TraineesRegister />} />

            <Route path="/groups/:commercialId/costs/:budgetSelect?" element={<Costs />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route exact path="/business" element={<Funil />} />
            <Route path="/business/new" element={<Business />} />
            <Route path="/business/edit/:businessId" element={<Business />} />
            <Route path="/business/newbudget/:commercialId/:budgetSelect?" element={<Costs />} />
            <Route path="/business/budget/:commercialId/:budgetSelect?" element={<Budget />} />
            <Route path="/business/feed/:businessId" element={<Feed />} />
            <Route path="/business/summary" element={<Summary />} />
            <Route path="/business/filter" exact element={<Funil />} />
            <Route path="/business/templatebusiness" exact element={<TemplateBusiness />} />
            <Route path="/business/templatebusiness/new" exact element={<TemplateBusinessEdith />} />
            <Route path="/business/templatebusiness/edit/:templateId" exact element={<TemplateBusinessEdith />} />
            <Route path="/attendance" exact element={<Attendance />} />
            <Route path="/attendance/edit/:attendanceId" element={<AttendanceMessage />} />
            <Route path="/financial" exact element={<financialRedirect />} />
            <Route path="/financial/managebills" element={<ManageBills />} />
            <Route path="/financial/billstoreceive" exact element={<BillsToReceive />} />
            <Route path="/financial/billstopay" exact element={<BillsToPay />} />
            <Route path="/groups" exact element={<Groups />} />
            <Route path="/reports" exact element={<Reports />} />
            <Route path="/reports/financial" exact element={<ReportsFinancial />} />
            <Route path="/reports/groups" exact element={<ReportsGroups />} />
            <Route path="/reports/business" exact element={<ReportsBusiness />} />
            <Route path="/reports/calendar" exact element={<ReportsCalendar />} />
            <Route path="/reports/operational" exact element={<ReportsOperational />} />
            <Route path="/reports/operational-suppliers" exact element={<ReportsOperationalSuppliers />} />
            <Route path="/reports/events" exact element={<ReportsEvents />} />
            <Route path="/reports/trainees" exact element={<ReportsTrainees />} />
            <Route path="/reports/attendance" exact element={<ReportsAttendance />} />
            <Route path="/reports/additional-items" exact element={<ReportsAdditionalItems />} />
            <Route path="/trainees" exact element={<Trainees />} />
            <Route path="/suppliers" exact element={<Suppliers />} />
            <Route path="/suppliers/edit/:suppliersId" element={<SuppliersRegister />} />
            <Route path="/suppliers/new" element={<SuppliersRegister />} />
            <Route path="/institutions" exact element={<Institutions />} />
            <Route path="/institutions/edit/:institucionId" element={<InstitutionsEdit />} />
            <Route path="/institutions/new" element={<InstitutionsEdit />} />
            <Route path="/users" exact element={<Users />} sidebar={false} />
            <Route path="/profile" exact element={<NewUser />} sidebar={false} />
            <Route path="/users/new" element={<NewUser />} sidebar={false} />
            <Route path="/users/edit/:userId" element={<NewUser />} sidebar={false} />
            <Route element={<RequireAdmin />}>
              <Route path="/admin/cost-center" element={<CostCenter />} />
              <Route path="/admin/events" element={<AdminEvents />} />
              <Route path="/admin/resources" element={<AdminResources />} />
              <Route path="/admin/calendar" element={<AdminCalendar />} />
              <Route path="/admin/competitors" element={<AdminCompetitors />} />
              <Route path="/admin/users" exact element={<AdminUsers />} />
              <Route path="/admin/users/:userId" element={<AdminUserEdit />} />
              <Route path="/admin/presets-permissions" element={<PresetsPermissions />} />
              <Route path="/admin/white-label" element={<WhiteLabel />} />
              <Route path="/no-permission" element={<NoPermission />} />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
